import { Injectable } from '@angular/core';
import { of, Subject, Subscription } from "rxjs";
import { delay, switchMap } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class SpinnerService {

    private showSubject = new Subject<boolean>();
    private showCount: number = 0
    private hideCount: number = 0

    public show(): void {
        this.showCount++
        this.showSubject.next(true)
    }

    public hide(): void {
        this.hideCount++
        if (this.hideCount == this.showCount) {
            this.showSubject.next(false)
        }
    }

    public subscribe(fn: (loading: boolean) => void): Subscription {
        return this.showSubject.pipe(
            switchMap(((loading: boolean) => {
                if (loading) {
                    return of(true).pipe(delay(900))
                }
                return of(false)
            })
            )).subscribe(fn)
    }

}
